import React, { createContext, useState, useContext, useCallback } from 'react';

const NavigationContext = createContext();

export function NavigationProvider({ children }) {
  const [activeRoute, setActiveRoute] = useState(null);
  const [navigationEnabled, setNavigationEnabled] = useState(false);
  const [routeInstructions, setRouteInstructions] = useState([]);
  const [nextInstruction, setNextInstruction] = useState(null);
  const [distanceToNextTurn, setDistanceToNextTurn] = useState(null);
  const [isOffRoute, setIsOffRoute] = useState(false);
  const [routeError, setRouteError] = useState(null);
  const [calculatingRoute, setCalculatingRoute] = useState(false);
  // Additional navigation state could be added here
  // For example: navigation mode (walking, driving, etc.)
  
  const startNavigation = (route) => {
    setActiveRoute(route);
    setNavigationEnabled(true);
  };
  
  const stopNavigation = useCallback(() => {
    console.log("NavigationContext stopNavigation");
    setActiveRoute(null);
    setRouteInstructions([]);
    setNextInstruction(null);
    setDistanceToNextTurn(null);
    setIsOffRoute(false);
    setRouteError(null);
  }, []);
  
  const setRouteFailure = useCallback((error, count) => {
    setRouteError(error);
  }, []);
  
  const clearRouteError = useCallback(() => {
    setRouteError(null);
  }, []);
  
  const value = {
    activeRoute,
    setActiveRoute,
    navigationEnabled,
    setNavigationEnabled,
    startNavigation,
    stopNavigation,
    routeInstructions,
    setRouteInstructions,
    nextInstruction,
    setNextInstruction,
    distanceToNextTurn,
    setDistanceToNextTurn,
    isOffRoute,
    setIsOffRoute,
    routeError,
    setRouteFailure,
    clearRouteError,
    calculatingRoute,
    setCalculatingRoute
  };
  
  return (
    <NavigationContext.Provider value={value}>
      {children}
    </NavigationContext.Provider>
  );
}

export function useNavigation() {
  const context = useContext(NavigationContext);
  if (context === undefined) {
    throw new Error('useNavigation must be used within a NavigationProvider');
  }
  return context;
} 